module.exports = __webpack_public_path__ + "img/share.d4608ab2.png";